// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".grid-toolbar.action-bar-wrapper .menu-toggler .settings-dropdown .dropdown-item {\n  padding: 4px 20px;\n}\n.grid-toolbar.action-bar-wrapper .btn.btn-secondary.dropdown-toggle {\n  color: var(--grid-toolbar-button);\n  background-color: transparent;\n  border: none;\n  top: -4px;\n}\n", ""]);
// Exports
module.exports = exports;
